import { toBig } from "@tradingApp/components/Trading/helpers/big";

export function percentsFromValue(
  value: string,
  totalValue: string,
  decimal = 0,
): string {
  const valueBig = toBig(value);
  const totalValueBig = toBig(totalValue);

  return totalValueBig.eq(0)
    ? "0"
    : valueBig.div(totalValueBig).mul(100).toFixed(decimal);
}
